import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

interface CollapsedIconWrapperProps {
  isCollapsed: boolean;
}

interface AccordionContentProps {
  controlHeight?: boolean;
}

export const Controls = styled(Box).attrs({
  bg: 'background',
  position: 'absolute',
  width: '250px',
})`
  top: 16px;
  right: 16px;
  z-index: 2;
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 5px;
  overflow: hidden;
  max-height: 75%;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
`;

export const AccordionTitleWrapper = styled(Box).attrs({
  bg: 'background',
  padding: '12px',
  height: '35px',
  horizontal: true,
  align: 'center',
  justify: 'center',
})`
  &:hover {
    background: ${({ theme }) => `${theme.colors.foreground}`};
  }
  cursor: pointer;
`;

export const AccordionTitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  margin: '5px',
})``;

export const CollapsedIconWrapper = styled(Box).attrs({
  ml: 'auto',
  transition: 'transform 0.6s ease',
})<CollapsedIconWrapperProps>`
  transform: ${p => (p.isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const AccordionContent = styled(Box).attrs({
  bg: 'background',
  padding: '10px 7px',
})<AccordionContentProps>`
  max-height: 75%
  height: ${({ controlHeight }) => (controlHeight ? `185px` : `auto`)};
  overflow: auto;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
`;

export const ControlsBottom = styled(Box).attrs({
  bg: 'background',
  padding: '6px 12px',
})`
  height: '60px';
  box-shadow: 0 -2px 5px 0 rgb(0, 0, 0, 0.13);
`;

export const SelectedLayersWrapper = styled(Box).attrs({
  bg: 'background',
  horizontal: true,
  align: 'center',
  justify: 'center',
  padding: '0 5px',
})``;

export const SelectedText = styled(Text).attrs({
  size: 'small',
  align: 'left',
  color: 'primaryText',
  marginRight: 'auto',
})``;

export const ClearAllText = styled(Text).attrs({
  size: 'small',
  align: 'right',
  color: 'secondaryText',
  padding: '5px',
})`
  justify-content: flex-end;
  cursor: pointer;
`;
